import { useGame } from '../state/GameContext';
import { useGameActions } from '../hooks/useGameActions';

export default function HomeScreen() {
  const { state, dispatch } = useGame();
  const { createRoom, joinRoom, rejoinSession } = useGameActions();

  if (state.currentView === 'join') {
    return (
      <div>
        <div className="form">
          <div className="input-group">
            <label className="label">Your Name</label>
            <input
              type="text"
              className="input"
              value={state.playerName}
              onChange={(e) => dispatch({ type: 'SET_FIELD', field: 'playerName', value: e.target.value })}
              placeholder="Enter your name"
              maxLength={20}
            />
          </div>
          <div className="input-group">
            <label className="label">Room Code</label>
            <input
              type="text"
              className="input"
              value={state.roomCode}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, '');
                dispatch({ type: 'SET_FIELD', field: 'roomCode', value });
              }}
              placeholder="Enter 6-digit code"
              maxLength={6}
              inputMode="numeric"
              pattern="[0-9]*"
            />
          </div>
        </div>

        <div className="form">
          <button
            className="button button-primary"
            onClick={joinRoom}
            disabled={state.loading || !state.roomCode.trim() || !state.playerName.trim()}
          >
            {state.loading ? 'Joining...' : 'Join Game'}
          </button>

          <button
            className="button button-secondary"
            onClick={() => dispatch({ type: 'SET_FIELD', field: 'currentView', value: 'home' })}
          >
            Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div>
      {localStorage.getItem('photoBlenderSession') && (
        <div className="mb-5 text-center">
          <button
            className="button button-primary mb-2.5"
            onClick={rejoinSession}
          >
            Rejoin Previous Game
          </button>
          <p className="text-sm opacity-70">
            or start a new game below
          </p>
        </div>
      )}

      <div className="form">
        <div className="input-group">
          <label className="label">Your Name</label>
          <input
            type="text"
            className="input"
            value={state.playerName}
            onChange={(e) => dispatch({ type: 'SET_FIELD', field: 'playerName', value: e.target.value })}
            placeholder="Enter your name"
            maxLength={20}
          />
        </div>
      </div>

      <div className="form">
        <button
          className="button button-primary"
          onClick={createRoom}
          disabled={state.loading || !state.playerName.trim()}
        >
          {state.loading ? 'Creating...' : 'Create New Game'}
        </button>

        <button
          className="button button-secondary"
          onClick={() => dispatch({ type: 'SET_FIELD', field: 'currentView', value: 'join' })}
          disabled={!state.playerName.trim()}
        >
          Join Existing Game
        </button>
      </div>
    </div>
  );
}
